// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1MMHZ","disabled":"FileBtn_disabled__p8Oiu","warn":"FileBtn_warn__Lk5to","fade":"FileBtn_fade__2JY1A"};